import React from 'react';
import { useIntl } from 'react-intl-next';

import { i18n } from './i18n';
import { QuickSummaryButtonWhitePlaceholder } from './QuickSummaryButtonWhitePlaceholder';
import type { QuickSummaryButtonStyles } from './QuickSummaryButton';

type QuickSummaryButtonPlaceholderProps = {
	summarizeText?: string;
	buttonStyles?: QuickSummaryButtonStyles;
};

export const QuickSummaryButtonPlaceholder = ({
	summarizeText,
	buttonStyles,
}: QuickSummaryButtonPlaceholderProps) => {
	const { formatMessage } = useIntl();
	const buttonText = summarizeText ?? formatMessage(i18n.quickSummaryToolTipText);

	return (
		<QuickSummaryButtonWhitePlaceholder summarizeText={buttonText} buttonStyles={buttonStyles} />
	);
};
